
const ShowingVSTelling = () => {
	return (
		<div>
			<h1>This is ShowingVSTelling component</h1>
		</div>
	)
}

export default ShowingVSTelling